/**
 * The `{{code:<codeId>}}` grammar, on its own so the remark plugin and the
 * Node probe (`scripts/probe-markdown-codes.mjs`) can import it without the
 * command client behind `codesUtils`.
 */
export const CODE_TOKEN_RE = /\{\{code:([a-z0-9-]{1,40})\}\}/g;
export const CODE_ID_RE = /^[a-z0-9-]{1,40}$/;
